<template>
<div class="writeWrapper"><span class="material-icons">edit</span>Contact us</div>
<ul>
    <li><span class="material-icons adIcon">language</span> Website</li>
    <li><img class="adlogo" src="../../../../public/logos/xing.png" alt="XING">XING</li>
    <li><img class="adlogo" src="../../../../public/logos/linkedin.png" alt="LinkedIn"> linkedIn</li>
    <li><img class="adlogo" src="../../../../public/logos/youtube.png" alt="YouTube"> YouTube </li>
    <li><img class="adlogo" src="../../../../public/logos/facebook2.png" alt="Facebook"> Facebook </li>
    <li><img class="adlogo" src="../../../../public/logos/xtwitter.png" alt="X"> X (Twitter)</li>
    <li><img class="adlogo" src="../../../../public/logos/instagram.png" alt="Insta"> Instagram</li> 
</ul>
</template>

<script>
export default {

}
</script>

<style scoped>
.writeWrapper{
    margin-left: 20%;
    margin-right: 20%;
    border: solid 4px black;  
    border-radius: 20px;
    padding: 10px;
    padding-right: 20px;
    padding-left: 20px;
    align-items: center;
    justify-content: space-evenly;
    display: flex;
}

.adlogo {
    width: 30px;
    margin-right: 10px;
}
    
.adIcon {
    font-size: 30px;
    margin-right: 10px;
    }

ul{
      margin: 0px;
      margin-top:10px;
      margin-left: 35px;
      list-style-type: none;
      padding: 0px;
    }

li{
      width: 85%;
      display: flex;
      align-items: center;
      justify-content: left;
      padding: 10px;
    }

li:hover{
      border-radius: 10%;
      background-color: lightgray;
    }
</style>